import css from 'styled-jsx/css';

export default css`.login-container {
  box-sizing: border-box;
  // 一些覆盖antd样式
  :global(.ant-input) {
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    background: #fff;
  }
  :global(.ant-select-selector) {
    border: none;
    box-shadow: none;
  }
  :global(.login-form-item-tel .ant-input-group-addon) {
    border: none;
    background: #fff;
    border-right: 1px solid rgba(204, 204, 204, 0.5);
    padding-left: 0;
    padding-right: 0;
  }
  :global(.login-form-item-smscode .ant-input-group-addon) {
    border: none;
    background: #fff;
    padding-left: 0;
    padding-right: 16px;
  }
  :global(.login-form-item-tel input) {
    width: 237px;
  }
  :global(.login-form-item-smscode input) {
    width: 160px;
  }
  :global(.ant-input-affix-wrapper) {
    border: none;
    padding-left: 16px;
    padding-right: 16px;
    background: transparent;
  }
  :global(.ant-form-item-control-input) {
    border: 1px solid rgba(216, 216, 216, 0.3);
    border-radius: 20px;
    overflow: hidden;
  }
  :global(.ant-form-item-has-error .ant-form-item-control-input) {
    border: 1px solid #ffa39e;
    background: #fff1f0;
  }
  :global(.select-region-code) {
    height: 38px;
    line-height: 38px;
    cursor: pointer;
  }
  :global(.select-region-code .region-code-select-modal) {
    position: fixed;
    z-index: 10;
  }
  :global(.select-region-code .code-show) {
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    align-items: center;
    background-color: #fff;
  }
  :global(.select-region-code .code) {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
  }
  :global(.select-region-code .arrow-icon) {
    font-size: 0;
    width: 10px;
    height: 6px;
    margin-left: 7px;
  }
  :global(.select-region-code .arrow-icon svg) {
    width: 100%;
    height: 100%;
    display: block;
  }
  :global(.select-region-code .arrow-icon-transform svg) {
    width: 100%;
    height: 100%;
    display: block;
    transform: rotateX(180deg);
  }
  :global(.ant-select-arrow) {
    color: #ccc;
  }
  :global(.get-pwd-btn) {
    font-size: 12px;
    font-weight: 400;
    color: #ff6400;
    border-left: 1px solid rgba(204, 204, 204, 0.5);
    cursor: pointer;
    line-height: 17px;
    padding-left: 16px;
    padding-right: 8px;
  }
  :global(.get-smscode-btn) {
    font-size: 12px;
    font-weight: 400;
    color: #ccc;
    border-left: 1px solid rgba(204, 204, 204, 0.5);
    cursor: pointer;
    line-height: 17px;
    padding-left: 16px;
    padding-right: 8px;
  }
  :global(.get-smscode-btn-active) {
    color: #ff6400;
  }
  :global(.ant-input-group input) {
    padding-left: 16px;
    padding-right: 16px;
    background: "#fff";
  }
  :global(.ant-input-group input:focus) {
    border: none;
    box-shadow: none;
  }
  :global(.ant-input-focused, .ant-input:focus) {
    box-shadow: none;
  }

  :global(input::-webkit-input-placeholder) {
    color: #ccc;
    font-size: 14px;
  }
  :global(input::-moz-input-placeholder) {
    color: #ccc;
    font-size: 14px;
  }
  :global(input::-ms-input-placeholder) {
    color: #ccc;
    font-size: 14px;
  }
  :global(input::placeholder) {
    color: #ccc;
    font-size: 14px;
  }
  :global(.account-tips) {
    font-size: 0;
  }
  :global(.account-tips svg) {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

// 内嵌页面
.login-container-component {
  padding-left: 24px;
  padding-right: 20px;
  :global(.login-submit-btn-bottom) {
    text-shadow: none
  }
  :global(.ant-form-item-explain, .ant-form-item-extra) {
    min-height: 20px;
    line-height: 20px;
  }
  :global(.ant-form-item) {
    margin-bottom: 2px;
  }
  :global(.ant-form-item-with-help) {
    margin-bottom: 0;
  }
}
`